// Representative flag icons; language codes and language names remain authoritative.
const LANGUAGE_REGIONS = {
    af: 'ZA', am: 'ET', ar: 'SA', as: 'IN', az: 'AZ', ba: 'RU', be: 'BY', bg: 'BG',
    bn: 'BD', br: 'FR', bs: 'BA', ca: 'ES', cs: 'CZ', cy: 'GB', da: 'DK', de: 'DE',
    el: 'GR', en: 'US', es: 'ES', et: 'EE', fa: 'IR', fi: 'FI', fo: 'FO', fr: 'FR',
    gl: 'ES', gu: 'IN', ha: 'NG', haw: 'US', he: 'IL', hi: 'IN', hr: 'HR', ht: 'HT',
    hu: 'HU', hy: 'AM', id: 'ID', is: 'IS', it: 'IT', ja: 'JP', jw: 'ID', ka: 'GE',
    kk: 'KZ', km: 'KH', kn: 'IN', ko: 'KR', lb: 'LU', ln: 'CD', lo: 'LA', lt: 'LT',
    lv: 'LV', mg: 'MG', mi: 'NZ', mk: 'MK', ml: 'IN', mn: 'MN', mr: 'IN', ms: 'MY',
    mt: 'MT', my: 'MM', ne: 'NP', nl: 'NL', nn: 'NO', no: 'NO', oc: 'FR', pa: 'IN',
    pl: 'PL', ps: 'AF', pt: 'PT', ro: 'RO', ru: 'RU', sa: 'IN', sd: 'PK', si: 'LK',
    sk: 'SK', sl: 'SI', sn: 'ZW', so: 'SO', sq: 'AL', sr: 'RS', su: 'ID', sv: 'SE',
    sw: 'TZ', ta: 'IN', te: 'IN', tg: 'TJ', th: 'TH', tk: 'TM', tl: 'PH', tr: 'TR',
    tt: 'RU', uk: 'UA', ur: 'PK', uz: 'UZ', vi: 'VN', yo: 'NG', yue: 'HK', zh: 'CN',
};
export function getLanguageFlag(code) {
    const region = LANGUAGE_REGIONS[code];
    return region ? String.fromCodePoint(...[...region].map(letter => 0x1f1e6 + letter.charCodeAt(0) - 65)) : '🌐';
}
